export const getFirstLettersFromUsername = (username: string) => {
  const strings = username.split(' ');
  return strings
    .map(item => item[0])
    .join('')
    .toUpperCase();
};
